/** @file The editor's projects REST client instance (browser fetch, same-origin cookies). */
import { createProjectsApi } from './createProjectsApi';

/** Used by the projects browser and the export dialog; tests pass their own fake clients instead. */
export const projectsApi = createProjectsApi((url, init) => fetch(url, init));
